export const ALL_CLASSES = 'all-classes'
export const JUST_ADDED = 'just-added'
export const TRENDING = 'trending'
export const MOST_POPULAR = 'most-popular'
export const COMING_SOON = 'coming-soon'
